/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface RtsOutboundAgingAndErrorsStgGet$Params {
  env?: string;
}

export function rtsOutboundAgingAndErrorsStgGet(http: HttpClient, rootUrl: string, params?: RtsOutboundAgingAndErrorsStgGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, rtsOutboundAgingAndErrorsStgGet.PATH, 'get');
  if (params) {
    rb.query('env', params.env, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

rtsOutboundAgingAndErrorsStgGet.PATH = '/Rts/outbound-aging-and-errors-stg';
